import { render, staticRenderFns } from "./BlockchainTracking.vue?vue&type=template&id=8b609444"
import script from "./BlockchainTracking.vue?vue&type=script&lang=js"
export * from "./BlockchainTracking.vue?vue&type=script&lang=js"
import style0 from "./BlockchainTracking.vue?vue&type=style&index=0&id=8b609444&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports